import {
  HlxDataCollect,
  HlxDataCollectShare,
  HlxDataCollectVideo
} from "@/api/types";
import Service from "@/api/index";
import store from "@/store";
import router from "@/router";
import Fingerprint2 from "fingerprintjs2";
interface Irecord {
  news: any;
  time?: number;
  sourceType?: string;
  ElVideoName?: string;
}
interface IrecordShare {
  platform: string;
  failReason: string;
}
let appId = 0;
// 浏览量
export async function recordCount(data: Irecord) {
  const ndata = getDataCollect(data);
  if (!ndata.session_id) {
    ndata.session_id = (await getMurmur()) as string;
  }
  Service.getHlxNewsRecordCount(ndata);
}
// 浏览时长
let visibilitychangeStartTime = 0;
let visibilitychangeData: Irecord;
async function visibilitychangeFun() {
  if (document.hidden) {
    const times = (new Date().getTime() - visibilitychangeStartTime) / 1000;
    const ndata = getDataCollect({
      news: visibilitychangeData.news,
      time: times,
      sourceType: visibilitychangeData.sourceType
    });
    if (!ndata.session_id) {
      ndata.session_id = (await getMurmur()) as string;
    }
    Service.getHlxNewsRecordTime(ndata);
  }
}
export function recordTime(data: Irecord) {
  visibilitychangeStartTime = new Date().getTime();
  visibilitychangeData = data;
  document.addEventListener("visibilitychange", visibilitychangeFun);
}
export function removRecordTime() {
  visibilitychangeStartTime = 0;
  document.removeEventListener("visibilitychange", visibilitychangeFun);
}
// 视频播放时长
let isplay = false;
let ispause = false;
let beforeunloadVideoPlayLength = 0;
let beforeunloadStartTime = 0;
let beforeunloadData: Irecord;
async function beforeunloadFun() {
  if (!isplay) return;
  if (!ispause)
    beforeunloadVideoPlayLength +=
      (new Date().getTime() - beforeunloadStartTime) / 1000;
  beforeunloadData.news.videoPlayLength = beforeunloadVideoPlayLength;
  const ndata = getDataCollectVideo(beforeunloadData);
  if (!ndata.sessionId) {
    ndata.sessionId = (await getMurmur()) as string;
  }
  Service.getHlxNewsRecordVideo(ndata);
}
export function recordVideo(data: Irecord) {
  setTimeout(() => {
    if (!data.ElVideoName) return;
    let elevideo = document.querySelector(data.ElVideoName) as any;
    if (elevideo.nodeName != "VIDEO") {
      for (let i = 0; i < elevideo.childNodes.length; i++) {
        if (elevideo.childNodes[i].nodeName == "VIDEO") {
          elevideo = elevideo.childNodes[i];
          break;
        }
      }
    }
    if (elevideo) {
      beforeunloadData = data;
      isplay = true;
      beforeunloadStartTime = new Date().getTime();
      beforeunloadData.news.duration = elevideo.duration;
      elevideo.addEventListener("play", () => {
        beforeunloadStartTime = new Date().getTime();
        ispause = false;
      });
      elevideo.addEventListener("pause", () => {
        ispause = true;
        beforeunloadVideoPlayLength +=
          (new Date().getTime() - beforeunloadStartTime) / 1000;
        beforeunloadFun();
      });
      window.addEventListener("beforeunload", beforeunloadFun);
    }
  }, 100);
}
export function removRecordVideo() {
  beforeunloadFun();
  setTimeout(() => {
    isplay = false;
    beforeunloadVideoPlayLength = 0;
    beforeunloadStartTime = 0;
    document.removeEventListener("beforeunload", beforeunloadFun);
  }, 1000);
}
// 分享
export async function recordShare(data?: IrecordShare) {
  // app中右上角分享后的回调
  if (window.ZWY_CLOUD.isOpenInApp() && !(window as any).cq_callBack_share) {
    (window as any).cq_callBack_share = function(value: any, share: any) {
      let shareType = "";
      if (share == "0") shareType = "微信朋友圈";
      if (share == "1") shareType = "微信好友";
      if (share == "2") shareType = "QQ空间";
      if (share == "3") shareType = "QQ好友";
      if (share == "4") shareType = "新浪微博";
      Service.getHlxNewsRecordShare(
        getDataCollectShare({
          platform: shareType,
          failReason: value == "1" ? "" : "用户取消分享"
        })
      );
    };
    return;
  }
  if (data) {
    const ndata = getDataCollectShare(data);
    if (!ndata.session_id) {
      ndata.session_id = (await getMurmur()) as string;
    }
    Service.getHlxNewsRecordShare(ndata);
  }
}
export function getDataCollect(data: Irecord): HlxDataCollect {
  appId = data.news.appId;
  const route = (router.app as any)._route;
  const par: HlxDataCollect = {
    app_id: appId,
    source_id: route.query.id,
    source_type: data.sourceType ? data.sourceType : "wz",
    url: window.location.href,
    send_source: "H5",
    token: store.state.token,
    session_id: store.state.sessionId,
    times: 0
  };
  // 浏览时长
  if (data.time) {
    par.times = parseInt(data.time + "");
  } else {
    delete par.times;
  }
  return par;
}
export function getDataCollectVideo(data: Irecord): HlxDataCollectVideo {
  appId = data.news.appId;
  const route = (router.app as any)._route;
  return {
    appId: appId,
    createTime: new Date().getTime(),
    sendSource: "H5",
    sessionId: store.state.sessionId,
    sourceId: route.query.id,
    sourceType: data.sourceType ? data.sourceType : "wz",
    token: store.state.token,
    url: window.location.href,
    videoPlayTimeLength: parseInt(data.news.videoPlayLength),
    videoTimeLength: parseInt(data.news.duration),
    videoUrl: data.news.contentUrl || data.news.bannerVideo
  };
}
export function getDataCollectShare(data: IrecordShare): HlxDataCollectShare {
  const route = (router.app as any)._route;
  return {
    app_id: appId,
    fail_reason: "",
    is_success: data.failReason ? "0" : "1",
    platform: data.platform,
    session_id: store.state.sessionId,
    source_id: route.query.id,
    source_type: "news",
    token: store.state.token,
    user_id: ""
  };
}

export function getMurmur() {
  const options = {
    excludes: {
      userAgent: true,
      audio: true,
      enumerateDevices: true,
      fonts: true,
      fontsFlash: true,
      webgl: true,
      canvas: true
    }
  };
  return new Promise((res, rej) => {
    Fingerprint2.get(options, function(components: any) {
      // 参数
      const values = components.map(function(component: any) {
        return component.value;
      });
      // 指纹
      const murmur = Fingerprint2.x64hash128(values.join(""), 31);
      res(murmur);
    });
  });
}
